var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDismiss, useFloating, useInteractions, useRole, } from '@floating-ui/react';
import { useId } from '../hooks';
import { Modal } from '../modal';
function DialogInternal(_a) {
    var { alignCenter = false, children, isOpen, onClose, role = 'dialog', size = 'medium' } = _a, restProps = __rest(_a, ["alignCenter", "children", "isOpen", "onClose", "role", "size"]);
    const id = `modal-${useId()}`;
    const { context, refs } = useFloating({
        onOpenChange: onClose,
        open: isOpen,
    });
    const { getFloatingProps } = useInteractions([
        useDismiss(context, {
            bubbles: false,
        }),
        useRole(context, { role }),
    ]);
    return (_jsx(Modal, Object.assign({}, Object.assign({ alignCenter,
        context, floatingProps: getFloatingProps({
            id,
            ref: refs.setFloating,
        }), isOpen,
        onClose,
        size }, restProps), { children: children })));
}
export default DialogInternal;
